<template>
  <div class="admin-page">
    <NavBarAdmin></NavBarAdmin>
    <router-view></router-view>
  </div>
</template>

<script>
import NavBarAdmin from '../components/NavBarAdmin';
export default {
  components: {
    NavBarAdmin,
  },
}
</script>
